<div class="page-container">
  <h2>Delete My Data</h2>
  <div class="delete-container">
    <p>If you previously authorized us to access data from social media platforms, you can request deletion here. We will remove the data we have collected for your creator account.</p>

    <form class="delete-form" *ngIf="!submitted" (ngSubmit)="submitRequest()" #deleteForm="ngForm">
      <label for="email">Email address</label>
      <input id="email" name="email" type="email" placeholder="name@example.com" required [(ngModel)]="email" />
      <button type="submit" [disabled]="deleteForm.invalid">Delete Data</button>
      <div class="form-hint">We use this email to locate your creator account and delete your data.</div>
    </form>

    <div *ngIf="submitted" class="success-message" role="status">
      <h3>Request received</h3>
      <p>Thanks! We have received your request and will delete the creator data associated with {{ email }}. We will follow up if we need any additional verification.</p>
      <p>If you have any questions, contact <a href="mailto:info@verticaltalentgroup.com">info&#64;verticaltalentgroup.com</a>.</p>
    </div>
  </div>
</div>
